import request from '@/utils/request';

export const pavilionList = ({page, pageSize=20, total}) => {
    return request.post('/hall/page', {
        page,
        pageSize,
        total
    })
}

// 展馆详情
export const hallDetail = (id) => {
    return request.post('/hall/detail', {
        id
    })
}